import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import FolderStats from '../../legos/FolderStats';
import s from './FolderCardFooter.scss';
const FolderCardFooter = ({ folder, className, isLocked, withPrice, oneLineDescription, showCountsWithoutCaptions, hideStats, children, t })=>{
    var _folder_premiumFolderData;
    const { formattedDollarPrice } = normalizePremiumFolderData(folder.premiumFolderData);
    const isPaid = ((_folder_premiumFolderData = folder.premiumFolderData) === null || _folder_premiumFolderData === void 0 ? void 0 : _folder_premiumFolderData.type) === 'paid';
    const withSubscribersCount = isPaid;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], oneLineDescription && s['one-line-description'], !hideStats && s['with-stats'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['folder-name'],
        title: folder.name
    }, folder.name), isLocked && /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('folderCard.locked'),
        usePortal: true
    }, /*#__PURE__*/ React.createElement(LockIcon, {
        className: s['lock-icon'],
        size: IconSize.SMALLER,
        condensed: true
    })), withPrice && isPaid && /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, formattedDollarPrice)), /*#__PURE__*/ React.createElement(Flex, null, !hideStats && /*#__PURE__*/ React.createElement(FolderStats, {
        folder: folder,
        withSubscribersCount: withSubscribersCount,
        showCountsWithoutCaptions: showCountsWithoutCaptions
    }))), children);
};
export default withTranslation()(FolderCardFooter);

//# sourceMappingURL=FolderCardFooter.js.map